<template>
  <search-group  :span="24" :btnOffset="18" :btnSpan ="6":inline="true" :multipleLines="true"   @search="findData" @clear="clearValue" >
    <Row class="mb16" :gutter="16">
      <Col span="5">
            <Select v-model="searchData.projectFid" placeholder="请选择项目">
              <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
      </Col>
      <Col span="6">
        <DatePicker v-model="payDate" split-panels type="daterange" format="yyyy-MM-dd" @on-change="changePayDate" placeholder="实际支付日期"></DatePicker>
      </Col>
      <Col span="5">
            <Select v-model="searchData.receiptStatus" placeholder="单据状态">
              <Option value=''>请选择</Option>
              <Option v-for="item in receiptStatusEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
      </Col>
      <Col span="4">
            <Select v-model="searchData.confirmStatus" placeholder="审核状态">
              <Option value=''>请选择</Option>
              <Option v-for="item in finReceiptAuditStatusEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
      </Col>
      <Col span="4">
        <Select
          v-model="searchData.stockFid"
          filterable
          remote
          :remote-method="remoteMethod"
          :loading="loading"
          placeholder="房间号"
        >
          <Option v-for="item in roomList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
    </Row>
    <Row :gutter="16">
      <Col span="3">
      <Select v-model="key" placeholder="关键字查询">
        <Option value=''>请选择</Option>
        <Option v-for="item in keyList" :value="item.value" :key="item.value">{{item.text}}</Option>
      </Select>
      </Col>
      <Col span="4">
        <Input type="text" v-model="keyValue" placeholder="请输入" @keyup.enter.native="findData"></Input>
      </Col>
    </Row>
  </search-group>
</template>

<script type="text/ecmascript-6">
import { formatDateTime } from '@/utils/format'
import { getProjects } from 'api/common'
import { fuzzyRoom } from 'api/functionalArea'
import { getConditions } from 'api/paymentVoucher'

export default {
  props:{

  },
  created(){
    this.initData()
  },
  watch:{

  },
  data () {
    return {
      roomList:[],
      finReceiptAuditStatusEnums:[],
      receiptStatusEnums:[],
      loading:false,
      projectList:[],
      payDate:[],
      key:'',
      keyValue:'',
      keyList:[
        {
          value:'contractCode',
          text:'合同号/预订单号'
        },
        {
          value:'billNum',
          text:'缴费凭证单号'
        }
      ],
      searchData:{
        projectFid:'',
        //startPayDate:'',
        //endPayDate:'',
        receiptStatus:'',
        confirmStatus:'',
        stockFid:'',
        limit: 10,
        page: 1
      }
    }
  },
  methods: {
    findData() {
      let key = this.key
      let value = this.keyValue
      this.searchData.page = 1
      let data = {}
      if(key && value) {
        data[key] = value
      }
      data = Object.assign({},data, this.searchData);
      this.$emit('findData',data)
    },
    changePayDate(val){
      this.searchData.startPayDate = val[0]
      this.searchData.endPayDate = val[1]
    },
    clearValue() {
      this.payDate  = []
      this.searchData.page = 1
      for( let key in this.searchData) {
        if(key === 'page' || key === 'limit' || 'projectFid') {
          continue
        }else {
          this.searchData[key] = ''
        }
      }
      this.key = ''
      this.keyValue = ''
    },
    initData(){
      getConditions().then( res => {
        this.finReceiptAuditStatusEnums = res.data.finReceiptAuditStatusEnums
        this.receiptStatusEnums =  res.data.receiptStatusEnums
      })
      getProjects().then( res => {
        this.projectList = res.data
        this.searchData.projectFid = this.projectList[0].value
        this.$emit('findData',this.searchData)
      })
    },
    remoteMethod(query){
      if (query !== '' && this.searchData.projectFid !=='') {
        this.loading = true;
        let params = {
          projectid:this.searchData.projectFid,
          roomnumber:query
        }
        fuzzyRoom(params).then( res => {
          this.loading = false;
          this.roomList = res.data;
        })
      } else {
          this.roomList = [];
          this.searchData.stockFid = ''
      }
    },
  }
}
</script>
<style scoped>
.dash {
  text-align: center;
}
.dash span {
  display: inline-block;
  width: 60%;
  height: 2px;
  background: #dddee1;
  vertical-align: middle;
}
.ivu-date-picker {
  width: 100%;
}
</style>

